/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarEquipmentDtoFromJSON, CarEquipmentDtoToJSON, GarageSpotAttributeDtoFromJSON, GarageSpotAttributeDtoToJSON, } from './';
export function GarageSpotCarEditDtoFromJSON(json) {
    return GarageSpotCarEditDtoFromJSONTyped(json, false);
}
export function GarageSpotCarEditDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'garageId': !exists(json, 'garageId') ? undefined : json['garageId'],
        'carEquipment': !exists(json, 'carEquipment') ? undefined : (json['carEquipment'] === null ? null : json['carEquipment'].map(CarEquipmentDtoFromJSON)),
        'attributeValues': !exists(json, 'attributeValues') ? undefined : (json['attributeValues'] === null ? null : json['attributeValues'].map(GarageSpotAttributeDtoFromJSON)),
    };
}
export function GarageSpotCarEditDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'garageId': value.garageId,
        'carEquipment': value.carEquipment === undefined ? undefined : (value.carEquipment === null ? null : value.carEquipment.map(CarEquipmentDtoToJSON)),
        'attributeValues': value.attributeValues === undefined ? undefined : (value.attributeValues === null ? null : value.attributeValues.map(GarageSpotAttributeDtoToJSON)),
    };
}
